import handleCart from './handleCart'
import authReducer from '../action/authSlice'
import chatReducer from '../action/chatSlice'
import { combineReducers } from "redux";

const rootReducers = combineReducers({
    handleCart,
    auth: authReducer,
    chat: chatReducer,
})
export default rootReducers